import { NxObjectFull } from '@warehouse/object-browser/core';
import { operations } from './inventory.openapi';
import { NxObjectAdapter } from './nx-object.adapter';
import { ProxyPlaybackAdapter } from './proxy-playback.adapter';

type GetNxObjectResponse = operations['get-nx-object']['responses']['200']['content']['application/json'];

export class NxObjectFullAdapter {
	static adapt(item: GetNxObjectResponse): NxObjectFull {
		const { proxy, ...metadata } = item.metadata;
		return {
			nxObject: NxObjectAdapter.adapt(item.nxObject),
			metadata: {
				...metadata,
				...(proxy ? { proxy: ProxyPlaybackAdapter.adapt(proxy) } : {}),
			},
		};
	}
}
